<template>
  <v-autocomplete
    density="compact"
    v-model="inputValue"
    v-bind:items="educationTypes"
    v-bind:item-title="(item) => objectTranslator(item, 'EDUCATION_TYPE_NAME')"
    v-bind:item-value="(item) => item.EDUCATION_TYPE_ID"
    v-bind:rules="inputRules"
    variant="outlined"
  ></v-autocomplete>
</template>
<script>
import { objectTranslator } from "../../helper/translator";
import validator from "@/helper/validator";
export default {
  name: "EducationType",
  props: {
    modelValue: String,
  },
  data: () => ({
    inputRules: [validator.required],
  }),
  methods: {
    objectTranslator,
    async fetch_data() {
      this.$store.dispatch("ref/getEducationTypes");
    },
  },
  computed: {
    educationTypes() {
      return this.$store.state.ref.educationTypes;
    },
    inputValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  created() {
    this.fetch_data();
  },
};
</script>
